module.exports = __webpack_public_path__ + "src/images/products/allAmerican/88_Seersucker Short Sleeve Camp Collar Shirt.png";